/**
 * Created by patricsherif on 13.07.15.
 */
'use strict';

angular.module('mobile-apps').factory('EntryCount', ['$resource',
    function($resource) {
        return $resource(
            '',
            {
            },
            {
                getCountForApps:
                {
                    url: '/v1/projects/:mobileAppId/entryCount/',
                    method:'GET',
                    cache : false
                },
                getCountforLanguages:
                {
                    url: '/v1/projects/:mobileAppId/languages/:languageId/entryCount/',
                    method:'GET',
                    cache : false
                },
                getAllCountforLanguages:
                {
                    url: '/v1/projects/:mobileAppId/languages/:languageId/groups/:groupId/allEntryCount/',
                    method:'GET',
                    cache : false
                },
                getCountforGroups:
                {
                    url: '/v1/projects/:mobileAppId/groups/:groupId/entryCount/',
                    method:'GET',
                    cache : false
                },
                getCountforGroupAndLanguage:
                {
                    url: '/v1/projects/:mobileAppId/languages/:languageId/groups/:groupId/entryCount/',
                    method:'GET',
                    cache : false
                }
            }
        );
    }
]);
